import { useEffect } from "react";
import SEO from "@/components/feature/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { aboutData } from "@/mocks/siteData";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "关于911爆料网",
  "description": "911爆料网成立于2023年，是国内领先的娱乐八卦资讯平台。致力于为广大网友提供最新、最全、最真实的网红黑料、明星八卦及社会奇闻资讯。",
  "url": "http://chiguabang.cn/about",
  "inLanguage": "zh-CN",
  "about": {
    "@type": "Organization",
    "name": "911爆料网",
    "url": "http://chiguabang.cn/",
    "description": "国内领先的娱乐八卦资讯平台",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "400-911-8888",
      "contactType": "customer service",
      "availableLanguage": "Chinese",
    },
  },
};

const faqAboutSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "911爆料网是什么平台？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "911爆料网是国内领先的娱乐八卦资讯平台，提供全网最新网红黑料、明星八卦及社会奇闻资讯。每日实时更新，确保用户第一时间获取最新爆料。",
      },
    },
    {
      "@type": "Question",
      "name": "如何向911爆料网提供爆料线索？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "您可以通过邮箱tips@chiguabang.cn或微信公众号911baoliao666向我们提供爆料线索。所有爆料均经过专业编辑团队的多方交叉验证，确保信息真实可靠。",
      },
    },
    {
      "@type": "Question",
      "name": "911爆料网的信息来源可靠吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "911爆料网坚持事实核查原则，每一条爆料都经过多方交叉验证。我们拥有遍布全国主要城市的线人网络和专业采编团队，确保信息真实可靠。",
      },
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们 - 911爆料网 | 品牌介绍·声誉·联系方式"
        description="911爆料网成立于2023年，是国内领先的娱乐八卦资讯平台。了解我们的品牌故事、平台使命和联系方式。全网覆盖、权威认证、极速更新。"
        keywords="911爆料网,关于我们,联系方式,品牌介绍,爆料平台"
        canonicalUrl="http://chiguabang.cn/about"
        ogTitle="关于我们 - 911爆料网"
        ogDescription="了解911爆料网的品牌故事、平台使命和联系方式。"
        ogType="website"
        schema={{ "@graph": [aboutSchema, faqAboutSchema] }}
      />
      <Navbar />
      <main>
        <section className="px-4 md:px-8 pt-16 pb-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </section>

        <section className="px-4 md:px-8 pb-12 md:pb-20">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20investigative%20journalism%20office%20aesthetic%2C%20vintage%20newspaper%20archive%20room%20with%20warm%20accent%20lighting%2C%20blurred%20background%20with%20filing%20cabinets%2C%20editorial%20professional%20atmosphere%2C%20deep%20shadows%20with%20subtle%20red%20glow%2C%20cinematic%20composition%2C%20moody%20photography&width=900&height=1125&seq=about-brand-img-01&orientation=portrait"
                  alt="911爆料网品牌形象"
                  className="w-full h-full object-cover"
                  title="911爆料网 - 品牌形象"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 rounded-full bg-background-100/60 backdrop-blur-sm text-foreground-300 text-xs font-medium whitespace-nowrap">
                    关于911
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-50 leading-tight">
                    关于我们
                  </h1>
                </div>
              </div>

              <div className="flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-50 mb-6">
                  品牌故事
                </h2>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
                  {aboutData.brandStory}
                </p>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
                  {aboutData.mission}
                </p>
                <div className="flex gap-3">
                  <a
                    href={`mailto:${aboutData.contact.email}`}
                    className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap dark:text-foreground-950 flex items-center gap-2"
                  >
                    联系我们
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </a>
                  <a
                    href={`tel:${aboutData.contact.phone}`}
                    className="px-6 py-2.5 border border-foreground-300/30 hover:bg-foreground-50/10 text-foreground-300 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    拨打电话
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              <div className="flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-6">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs text-foreground-500 font-medium tracking-wider">平台使命</span>
                </div>
                <blockquote className="text-xl md:text-2xl lg:text-3xl font-heading text-foreground-100 leading-relaxed mb-4">
                  &ldquo;让每一个瓜都有据可查，让每一份爆料都经得起推敲。我们追求的不只是速度，更是真相。&rdquo;
                </blockquote>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-300">911爆料网编辑部</span>
                  <span className="flex items-center gap-1 text-xs text-accent-400">
                    <i className="ri-verified-badge-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                    官方认证
                  </span>
                </div>
              </div>
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Black%20and%20white%20editorial%20portrait%20of%20a%20person%20in%20profile%2C%20head%20slightly%20tilted%20up%2C%20shoulders%20and%20above%2C%20dramatic%20side%20lighting%2C%20pure%20white%20background%2C%20journalist%20aesthetic%2C%20cinematic%20photography%20style%2C%20film%20grain%20texture&width=900&height=1125&seq=about-mission-portrait-01&orientation=portrait"
                  alt="911爆料网品牌大使"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="mb-4">
              <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase">平台优势</span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-50 mb-12">
              为什么选择911爆料网
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {aboutData.advantages.map((adv) => (
                <div
                  key={adv.title}
                  className="group bg-background-200/70 rounded-xl p-6 md:p-8 border border-background-300/40 hover:border-background-300 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-800 mb-5">
                    <i className={`${adv.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-medium text-foreground-100 mb-3">{adv.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{adv.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-50 mb-3 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              如果您有任何爆料线索或合作意向，欢迎通过以下方式与我们取得联系
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-background-100 rounded-xl p-5 border border-background-300/30 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100/50 text-primary-500 mx-auto mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h4 className="text-sm font-medium text-foreground-200 mb-1">电子邮箱</h4>
                <a
                  href={`mailto:${aboutData.contact.email}`}
                  className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer break-all"
                >
                  {aboutData.contact.email}
                </a>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-300/30 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100/50 text-accent-600 mx-auto mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <h4 className="text-sm font-medium text-foreground-200 mb-1">联系电话</h4>
                <a
                  href={`tel:${aboutData.contact.phone}`}
                  className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {aboutData.contact.phone}
                </a>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-300/30 text-center sm:col-span-2 lg:col-span-1">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100/50 text-secondary-700 mx-auto mb-3">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <h4 className="text-sm font-medium text-foreground-200 mb-1">微信公众号</h4>
                <span className="text-xs text-foreground-500">{aboutData.contact.wechat}</span>
              </div>
            </div>
            <div className="mt-6 bg-background-100 rounded-xl p-5 border border-background-300/30 text-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-100/10 text-foreground-400 mx-auto mb-3">
                <i className="ri-map-pin-line text-lg"></i>
              </div>
              <h4 className="text-sm font-medium text-foreground-200 mb-1">公司地址</h4>
              <p className="text-xs text-foreground-500">{aboutData.contact.address}</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}